import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { getMessageIdentifier, Headband, IHeadband } from '../models/headband.model';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../app/config/input.constants';
import { map } from 'rxjs/operators';

type EntityType = Headband;

export type EntityResponseType = HttpResponse<EntityType>;
export type EntityArrayResponseType = HttpResponse<EntityType[]>;

@Injectable({ providedIn: 'root' })
export class DisplayHeadbandModeratorService implements IBaryTableFetchService<IHeadband> {
  protected resourceUrl = API_ENDPOINTS.HEADBANDS;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  fillDataToShow(entities: IHeadband[]): Observable<IHeadband[]> {
    return of(entities);
  }

  create(headband: IHeadband): Observable<EntityResponseType> {
    const copy = this.convertDateFromHeadband(headband);
    return this.apiProvider.post<EntityType>(this.resourceUrl, copy).pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(headband: IHeadband): Observable<EntityResponseType> {
    const copy = this.convertDateFromHeadband(headband);
    return this.apiProvider.put<EntityType>(`${this.resourceUrl}/${getMessageIdentifier(headband)}`, copy).pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  partialUpdate(headband: IHeadband): Observable<EntityResponseType> {
    return this.apiProvider
      .put<EntityType>(`${this.resourceUrl}/${getMessageIdentifier(headband)}`, headband)
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<IHeadband>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<IHeadband[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  getCurrentHeadbands(transporterId: number): Observable<HttpResponse<Headband[]>> {
    return this.apiProvider.get<Headband[]>(`${this.resourceUrl}/currentHeadbands/${transporterId}`);
  }

  convertDateFromHeadband(headband: Headband): Headband {
    return Object.assign({}, headband, {
      startDate: dayjs(headband.startDate).isValid() ? dayjs(headband.startDate).format(DATE_FORMAT) : undefined,
      endDate: dayjs(headband.endDate).isValid() ? dayjs(headband.endDate).format(DATE_FORMAT) : undefined,
    });
  }

  //
  convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      res.body.startDate = res.body.startDate ? dayjs(res.body.startDate).toDate() : undefined;
      res.body.endDate = res.body.endDate ? dayjs(res.body.endDate).toDate() : undefined;
    }
    return res;
  }
}
